import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { useQuoteForm } from "@/hooks/useQuoteForm";

const inputCls = "w-full bg-transparent border rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[var(--red)] transition-colors";

export const QuickQuote = ({ expoName = "", source = "page" }) => {
  const { form, submitted, submitting, error, onChange, onSubmit } = useQuoteForm();

  if (submitted) {
    return (
      <div data-testid="quick-quote-success" className="rounded-2xl p-8 text-center" style={{ background: "var(--surface)", border: "1px solid var(--red)" }}>
        <div className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ background: "var(--red)" }}><Check size={22} /></div>
        <h3 className="font-display text-2xl mb-2">Brief received.</h3>
        <p className="text-sm text-[var(--text-soft)]">Expect 3D concepts and an itemised quote within 72 hours.</p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} data-testid={`quick-quote-${source}`} className="rounded-2xl p-6 md:p-8" style={{ background: "var(--surface)", border: "1px solid var(--line-strong)" }}>
      <div className="shg-eyebrow mb-3">Free 3D design + quote in 72h</div>
      <h3 className="font-display text-2xl md:text-3xl mb-5">
        Exhibiting{expoName ? ` at ${expoName}` : " soon"}? Get a fixed-price quote.
      </h3>
      <div className="grid sm:grid-cols-2 gap-3 mb-3">
        <input data-testid="qq-name" name="name" required minLength={2} placeholder="Your name" value={form.name} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)" }} />
        <input data-testid="qq-email" name="email" type="email" required placeholder="Work email" value={form.email} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)" }} />
        <input data-testid="qq-phone" name="phone" placeholder="Phone / WhatsApp" value={form.phone} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)" }} />
        <input data-testid="qq-expo" name="expo" placeholder={expoName ? expoName : "Expo / event name"} value={form.expo || ""} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)" }} />
        <input data-testid="qq-size" name="size" placeholder="Stand size (sqm / sq ft)" value={form.size} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)" }} />
        <select data-testid="qq-budget" name="budget" value={form.budget} onChange={onChange} className={inputCls} style={{ borderColor: "var(--line-strong)", background: "var(--surface)" }}>
          <option value="">Budget (optional)</option>
          <option>Under 10,000</option>
          <option>10,000 – 20,000</option>
          <option>20,000 – 40,000</option>
          <option>40,000 – 80,000</option>
          <option>80,000+</option>
          <option>Not decided yet</option>
        </select>
        <input name="website" value={form.website} onChange={onChange} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />
      </div>
      {error && <p data-testid="qq-error" className="text-sm text-[var(--red)] mb-3">{error}</p>}
      <button data-testid="qq-submit" type="submit" disabled={submitting} className="btn-primary w-full justify-center disabled:opacity-60">
        {submitting ? "Sending…" : "Send my brief"} <ArrowUpRight size={16} />
      </button>
      <p className="text-[11px] text-[var(--text-muted)] mt-3">No agency mark-up · Fixed price · Reply within 24h · By sending you agree to our <Link to="/privacy" className="underline hover:text-[var(--red)]">Privacy Policy</Link></p>
    </form>
  );
};

export default QuickQuote;
